module.exports = __webpack_public_path__ + "static/Logo-white-7175b1b97d29585648116449d64cb2bf.svg";